import { z } from 'zod';
import { TextKey } from '@mews-commander/enums';

export enum GroupsAndReservationsDialogFormKeys {
    groupsAndReservations = 'groupsAndReservations',
    reservationsWithGroupChecked = 'reservationsWithGroupChecked',
}

export const GroupsAndReservationsDialogFormSchema = z.object({
    [GroupsAndReservationsDialogFormKeys.groupsAndReservations]: z
        .array(z.string())
        .min(1, { message: TextKey.RoutingRulesFormGroupsAndReservationsDialogErrorMessage }),
    [GroupsAndReservationsDialogFormKeys.reservationsWithGroupChecked]: z.array(z.string()).optional(),
});
export type GroupsAndReservationsDialogFormValues = z.infer<typeof GroupsAndReservationsDialogFormSchema>;
